<template>
    <NavigationLinksTemplate :nav-links="navLinks"></NavigationLinksTemplate>
</template>

<script setup lang="ts">
import { computed, ComputedRef } from 'vue';
import { NavigationLink } from '@/types';
import { CalendarIcon, ClockIcon, CreditCardIcon, HomeIcon } from '@heroicons/vue/solid';
import NavigationLinksTemplate from '@/components/navigation/NavigationLinksTemplate.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const navLinks: ComputedRef<NavigationLink[]> = computed(() => {
    return     [
        {
            label: t('navigation.home'),
            route: 'dashboard',
            icon: HomeIcon
        },
        {
            label: t('navigation.transactions'),
            route: 'transactions',
            icon: ClockIcon
        },
        {
            label: t('navigation.paymentMethods'),
            route: 'paymentMethods',
            icon: CreditCardIcon
        },
        {
            label: t('navigation.recurringGifts'),
            route: 'recurringGifts',
            icon: CalendarIcon
        }
    ];
});
</script>
